import useGetPopularProductsConfig from './useGetPopularProductsConfig'

export default useGetPopularProductsConfig
